export const SET_FIRST_LOAD = 'SET_FIRST_LOAD';
export const SET_IMPERSONATED = 'SET_IMPERSONATED';
export const CLEAR_STATE = 'CLEAR_STATE';
export const SET_IMPERSONATED_USER_SUCCESS = 'SET_IMPERSONATED_USER_SUCCESS';
